require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// ../~/angular/index.js
// module id = 47
// module chunks = 0